<template>
  <div class="w-full sm:w-1/2">
    <div v-for="day in daysOfWeek" :key="day" class="vx-row mt-2">
      <div class="vx-col sm:w-4/12 w-full">
        <p class="pt-2">{{ formattedDays[daysOfWeek.indexOf(day)] }}</p>
      </div>
      <div class="vx-col select-open-or-closed sm:w-8/12 w-full">
        <v-select
          v-model="localOperations[day]"
          :options="getOptions(day)"
          :reduce="option => option.value"
          @input="onDayInput(day)"
          :placeholder="`Select ${formattedDays[daysOfWeek.indexOf(day)]} status`"
          class="w-full"
          :class="{
            'is-danger': showValidationErrors && !isValidStatus(localOperations[day])
          }"
        />
      </div>
    </div>
  </div>
  
</template>

<script>
import vSelect from 'vue-select';
import { capitalizeFirstLetter, toPluralOperationsMap } from '../globalHelpers/string';

export default {
  name: 'DeliveryOperatingDays',
  components: { vSelect },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openClosedOptions: [
        { label: 'Open', value: 'Open' },
        { label: 'Closed', value: 'Closed' },
      ],
      daysOfWeek: ['mondays', 'tuesdays', 'wednesdays', 'thursdays', 'fridays', 'saturdays', 'sundays'],
      showValidationErrors: false,
      localOperations: {
        mondays: null,
        tuesdays: null,
        wednesdays: null,
        thursdays: null,
        fridays: null,
        saturdays: null,
        sundays: null,
      },
    };
  },
  computed: {
    formattedDays() {
      return this.daysOfWeek.map(day => capitalizeFirstLetter(day).slice(0, -1));
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.initLocalOperations(newVal);
      },
    },
  },
  methods: {
    initLocalOperations(val = {}) {
      const pluralOps = toPluralOperationsMap(val);
      this.localOperations = this.daysOfWeek.reduce((acc, day) => {
        acc[day] =  pluralOps[day] != null ? pluralOps[day] : null;
        return acc;
      }, {});
    },
    getOptions(day) {
      const value = this.localOperations[day];
      const base = this.openClosedOptions.slice();
      const normalized = value == null ? null : String(value);
      if (
        normalized &&
        !['open', 'closed'].includes(normalized.toLowerCase())
      ) {
        base.unshift({ label: `${normalized}`, value: normalized });
      }
      return base;
    },
    isValidStatus(value) {
      return value && ['open', 'closed'].includes(String(value).toLowerCase());
    },
    onDayInput() {
      const out = this.daysOfWeek.reduce((acc, key) => {
        acc[key] = this.localOperations[key];
        return acc;
      }, {});
      this.$emit('input', out);
    },
    validateAllDays() {
      this.showValidationErrors = true;
      const allValid = this.daysOfWeek.every(day =>
        this.isValidStatus(this.localOperations[day])
      );
      if (!allValid) {
        this.$vs && this.$vs.notify && this.$vs.notify({
          title: 'Validation Error',
          text: 'Please select valid operating status for all days',
          color: 'danger',
          time: 4000,
        });

        this.$nextTick(() => {
          const firstInvalid = document.querySelector('.is-danger');
          if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      return allValid;
    },
  },
  created() {
    this.initLocalOperations(this.value);
  },
};
</script>

<style scoped>
/* Show red border on vue-select when invalid */
.is-danger >>> .vs__dropdown-toggle,
.is-danger /deep/ .vs__dropdown-toggle {
  border-color: #EA5455 !important;
}

.is-danger >>> .vs__dropdown-toggle:focus,
.is-danger /deep/ .vs__dropdown-toggle:focus {
  box-shadow: 0 0 0 2px rgba(234, 84, 85, 0.2);
}
</style>


